/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   FarAwayMoveInContainer
 */

import { selectIsMobile } from '@zcode-ui/web-zumper-global-state'
import { DETAIL_CALL } from '@zcode-ui/web-zumper-integrations'
import type { Origin } from '@zcode/nr-utils'
import { trackOptimizelyPhoneEvents } from '@zcode/nr/es/shared/thirdParty/optimizely/thunks'
import type { State } from '@zcode/state-type'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import { mixpanelCall } from '../../../../../modules/mixpanel/thunks/mixpanelCall'
import { selectEntity } from '../../../../../modules/modals/selectors/messageModal/index'
import { trackDetailEvent } from '../../../../../modules/traktor/thunks/trackDetailEvent'
import { trackCallEvent } from '../../../../../utils/trackCallEvent'
import { FarAwayMoveIn, type FarAwayMoveInProps } from './FarAwayMoveIn'

interface FarAwayMoveInContainerProps {
  origin: Origin
}

const mapStateToProps = (state: State) => {
  const entity = selectEntity(state)
  const { agent, paidPhoneHref } = entity || {}
  const { phoneHref } = agent || {}
  return {
    isMobile: selectIsMobile(state),
    phoneHref: paidPhoneHref || phoneHref,
  } satisfies Partial<FarAwayMoveInProps>
}

const mapDispatchToProps = (dispatch: Dispatch, ownProps: FarAwayMoveInContainerProps) => {
  return {
    onPhoneClick: () => {
      dispatch((_, getState) => {
        const state = getState()
        const entity = selectEntity(state)
        dispatch(trackDetailEvent({ entity, name: DETAIL_CALL }))
        dispatch(trackOptimizelyPhoneEvents({ entity }))
        dispatch(mixpanelCall({ entity, origin: ownProps.origin }))
        trackCallEvent(entity ?? undefined)
      })
    },
  } satisfies Partial<FarAwayMoveInProps>
}

export const FarAwayMoveInContainer = connect(mapStateToProps, mapDispatchToProps)(FarAwayMoveIn)
